import { BeckyModel, ComponentsNativeMappers, NativeExtension } from '@wix/thunderbolt-becky-root'
import _ from 'lodash'
import * as AddressInput from './components/AddressInput/AddressInput.mapper'
import * as AppPart from './components/AppPart/AppPart.mapper'
import * as AppPart2 from './components/AppPart/AppPart2.mapper'
import * as AppWidget from './components/AppWidget/AppWidget.mapper'
import * as BackgroundGroup from './components/BackgroundGroup/BackgroundGroup.mapper'
import * as BackToTopButton from './components/BackToTopButton/BackToTopButton.mapper'
import * as Checkbox from './components/Checkbox/Checkbox.mapper'
import * as CheckboxGroup from './components/CheckboxGroup/CheckboxGroup.mapper'
import * as ClassicSection from './components/ClassicSection/ClassicSection.mapper'
import * as ComboBoxInput from './components/ComboBoxInput/ComboBoxInput.mapper'
import * as ComboBoxInputListModal from './components/ComboBoxInput/ComboBoxInputListModal.mapper'
import * as DatePicker from './components/DatePicker/DatePicker.mapper'
import * as FacebookLikeBox from './components/FacebookLikeBox/FacebookLikeBox.mapper'
import * as FileUploader from './components/FileUploader/FileUploader.mapper'
import * as FiveGridLine from './components/FiveGridLine/FiveGridLine.mapper'
import * as ItunesButton from './components/ItunesButton/ItunesButton.mapper'
import * as LanguageSelector from './components/LanguageSelector/LanguageSelector.mapper'
import * as LinkBar from './components/LinkBar/LinkBar.mapper'
import * as LoginSocialBar from './components/LoginSocialBar/LoginSocialBar.mapper'
import * as PaginatedGridGallery from './components/PaginatedGridGallery/PaginatedGridGallery.mapper'
import * as Pagination from './components/Pagination/Pagination.mapper'
import * as PopupCloseIconButton from './components/PopupCloseIconButton/PopupCloseIconButton.mapper'
import * as RadioGroup from './components/RadioGroup/RadioGroup.mapper'
import * as RatingsDisplay from './components/RatingsDisplay/RatingsDisplay.mapper'
import * as RatingsInput from './components/RatingsInput/RatingsInput.mapper'
import * as ResponsivePopupPage from './components/ResponsivePopupPage/ResponsivePopupPage.mapper'
import * as SignatureInput from './components/SignatureInput/SignatureInput.mapper'
import * as SiteButton from './components/SiteButton/SiteButton.mapper'
import * as StripColumnsContainer from './components/StripColumnsContainer/StripColumnsContainer.mapper'

export type MergeMappers = (
	mappers: ComponentsNativeMappers,
	isExperimentOpen: (name: keyof BeckyModel['experiments']) => boolean
) => ComponentsNativeMappers

export const mergeMappers: MergeMappers = (mappers, isExperimentOpen) => {
	// You can use isExperimentOpen here in order to decide which native mappers to merge (for risky changes)
	const componentsMappers = {
		AppPart,
		AppPart2,
		...(isExperimentOpen('specs.thunderbolt.native_css_mappers') && {
			AddressInput,
			AppWidget,
			BackgroundGroup,
			BackToTopButton,
			Checkbox,
			CheckboxGroup,
			ComboBoxInput,
			ComboBoxInputListModal,
			DatePicker,
			FacebookLikeBox,
			FileUploader,
			FiveGridLine,
			ItunesButton,
			LanguageSelector,
			LinkBar,
			LoginSocialBar,
			PaginatedGridGallery,
			Pagination,
			PopupCloseIconButton,
			RadioGroup,
			RatingsDisplay,
			RatingsInput,
			ResponsivePopupPage,
			SignatureInput,
			SiteButton,
		}),
		...(isExperimentOpen('specs.thunderbolt.StripColumnsContainerMapper') && {
			StripColumnsContainer,
			ClassicSection,
		}),
	}

	return _.assignWith(
		{},
		mappers,
		componentsMappers,
		(external: ComponentsNativeMappers[string], internal: ComponentsNativeMappers[string]) => {
			// If only EE or internal component definition (e.g. all mappers), return it
			if (!external || !internal) {
				return external || internal
			}

			return _.assignWith({}, external, internal, (ext, int) => {
				// If only EE or internal mapper exists, return it
				if (!ext || !int) {
					return ext || int
				}

				// If both internal and EE mapper exist, merge them
				const mapper: NativeExtension = {
					deps: { ...int.deps, ...ext.deps },
					resolver: (deps, carmiProps) => {
						// Calculate CARMI data using internal mapper, then pass it to the EE mapper
						const carmiData = int.resolver(deps, carmiProps)
						return ext.resolver(deps, carmiData)
					},
				}

				return mapper
			})
		}
	)
}
